export default {
  title: 'Maandoverzichten',
  list: {
    empty_list: {
      title: 'Nog geen maandoverzichten.',
    },
    fields: {
      month: 'Maand',
      stripe_service_invoice_url: 'Stripe-factuur',
      paypal_service_invoice_url: 'PayPal-factuur',
    },
    button: {
      title: 'Exporteren',
    },
  },
  export_modal: {
    title: 'Exporteren',
    start_date: {
      title: 'Startdatum',
      placeholder: 'datum',
    },
    end_date: {
      title: 'Einddatum',
      placeholder: 'datum',
    },
    button: {
      export: 'Exporteren',
      close: 'Sluiten',
    },
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
  },
};
